import { CALENDAR_SET_DATE, CALENDAR_CHANGE_DATE } from './constants';

/** **************************************
 * On Change Handler
 *************************************** */

export function changeDate(startDate, endDate) {
  return { type: CALENDAR_CHANGE_DATE, payload: { startDate, endDate } };
}

/** **************************************
 * Setter
 *************************************** */

export function setDate(startDate, endDate) {
  return { type: CALENDAR_SET_DATE, payload: { startDate, endDate } };
}
